import React, { useEffect, useState } from "react";

const FIELDS = [
  ["supplierLeadDays", "Supplier lead time (days)"],
  ["transitDays", "Transit to AWD or FBA (days)"],
  ["awdToFbaDays", "AWD to FBA transit (days)"],
  ["safetyDays", "Safety stock (days)"],
  ["targetCoverDays", "Reorder up to (days of sales)"],
  ["redCoverBelowDays", "Mark red when cover is below (days)"],
  ["excessCoverDays", "Excess when cover is above (days)"],
  ["claimRedWithinDays", "Mark claims red when window closes within (days)"],
  ["planNotShippedDays", "Plan not shipped after (days)"],
  ["placementFeeOverCheapest", "Placement fee over cheapest (amount)"],
  ["laneTransitDays", "Normal transit time (days)"],
  ["deliveredNotReceivingDays", "Delivered, not receiving after (days)"],
  ["receivingStalledDays", "Receiving unchanged for (days)"],
];

const CLAIMS = [
  ["inboundShort", "Units missing from inbound shipment"],
  ["lostDamaged", "Lost or damaged in warehouse"],
  ["returnNotReceived", "Customer return not received"],
  ["removalLost", "Removal lost in transit"],
];

/** Edits apply to this view only (sent with the request). Saving per store comes with the settings table. */
export default function AlertSettings({ settings }) {
  const [draft, setDraft] = useState(settings);
  const [costs, setCosts] = useState("");

  useEffect(() => {
    setDraft(settings);
    setCosts(Object.entries((settings && settings.unitCosts) || {}).map(([k, v]) => `${k}, ${v}`).join("\n"));
  }, [settings]);

  return (
    <div>
      <p className="ia-lead">Alert settings are currently view-only (read-only).</p>
      <div className="ia-card ia-form">
        <h3 className="ia-subtitle">Replenishment and urgency</h3>
        <div className="ia-form__grid">
          {FIELDS.map(([key, label]) => (
            <label key={key} className="ia-field">
              <span>{label}</span>
              <input
                className="ia-input"
                type="number"
                min="0"
                disabled
                readOnly
                style={{ backgroundColor: "#f4f5f7", cursor: "not-allowed", color: "#5f666d" }}
                value={draft && draft[key] != null ? draft[key] : ""}
              />
            </label>
          ))}
        </div>
      </div>

      <div className="ia-card ia-form">
        <h3 className="ia-subtitle">Claim windows</h3>
        <p className="ia-muted">Amazon changes these. Confirm them in Seller Central Help for each marketplace.</p>
        <table className="ia-table ia-table--compact">
          <thead>
            <tr>
              <th>Claim type</th>
              <th>Can file after (days)</th>
              <th>Must file within (days)</th>
              <th>Counted from</th>
            </tr>
          </thead>
          <tbody>
            {CLAIMS.map(([type, label]) => {
              const win = draft && draft.claimWindows && draft.claimWindows[type];
              return (
                <tr key={type}>
                  <td>{label}</td>
                  <td>
                    <input
                      className="ia-input ia-input--small"
                      type="number"
                      min="0"
                      disabled
                      readOnly
                      style={{ backgroundColor: "#f4f5f7", cursor: "not-allowed", color: "#5f666d" }}
                      value={win && win.opensAfter != null ? win.opensAfter : ""}
                    />
                  </td>
                  <td>
                    <input
                      className="ia-input ia-input--small"
                      type="number"
                      min="0"
                      disabled
                      readOnly
                      style={{ backgroundColor: "#f4f5f7", cursor: "not-allowed", color: "#5f666d" }}
                      value={win && win.closesAfter != null ? win.closesAfter : ""}
                    />
                  </td>
                  <td>{win ? win.countedFrom : ""}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="ia-card ia-form">
        <h3 className="ia-subtitle">Unit costs</h3>
        <p className="ia-muted">One SKU per line: SKU, cost. Claims are valued at cost when given, otherwise at selling price.</p>
        <textarea
          className="ia-input ia-textarea"
          rows={5}
          disabled
          readOnly
          style={{ backgroundColor: "#f4f5f7", cursor: "not-allowed", color: "#5f666d" }}
          value={costs}
          placeholder={"MUG-BLK-12, 4.10\nTOWEL-GRY-2P, 9.80"}
        />
      </div>

      <div className="ia-form__actions">
        <button
          type="button"
          className="ia-btn ia-btn--primary"
          disabled
          style={{ cursor: "not-allowed", opacity: 0.6 }}
          title="Settings are currently read-only"
        >
          Apply to this view
        </button>
        <button
          type="button"
          className="ia-btn"
          disabled
          style={{ cursor: "not-allowed", opacity: 0.6 }}
          title="Settings are currently read-only"
        >
          Reset to defaults
        </button>
      </div>
    </div>
  );
}
